export const COMPANY_SHORT_NAME = 'Dhruv Consultancy';
export const COMPANY_LEGAL_NAME = 'Dhruv Consultancy Services Ltd';
export const WORKSPACE_LABEL = 'Workspace';
export const TENDER_APP_NAME = 'Tender Management';

export const WORKSPACE_TAGLINE = 'A connected workspace for your business applications.';

export function documentTitle(suffix) {
  if (!suffix || suffix === WORKSPACE_LABEL) {
    return `${COMPANY_SHORT_NAME} | ${WORKSPACE_LABEL}`;
  }
  return `${COMPANY_SHORT_NAME} | ${suffix}`;
}
